import React from "react"

/**
 * Data comes from the template to render the specific alerts for a page/post/category
*/


function Alert(props) {
  if(props.data !== null) {
    const alertData = props.data.alert.map((alertInfo) => {
      return (
      <div id={`alert-${alertInfo.id}`} class="alert__aside mbottom-20" key={alertInfo}>
        <div class="alert__item">
          <div className={`alert__message alert--state-${alertInfo.acf_alertstyle.alertLevel}`} >
            <div className="alert__content">
              <div>
              <h6>{alertInfo.title}</h6>
              <div dangerouslySetInnerHTML={{ __html: `${alertInfo.content}` }}/>
              </div>
            </div>
          </div>
        </div>
      </div>
      )
  }
  );
  return (
    <div className="alert  dont-print" aria-label="Alerts">
      <div id="alerts" className="alert__item">
        <div className="element--inner clearfix">
          <h4 class="heading alert__heading">Alerts</h4>
          {alertData}
        </div>
      </div>
    </div>
  )
  } else {
    return null;
  }
}
export default Alert